import { useLocation } from '@reach/router';
import queryString from 'query-string';
import { useMemo } from 'react';

export function useIsHiddenByQueryParam(
  paramStrings: string[]
): Array<boolean> {
  const location = useLocation();
  const params = queryString.parse(location.search);

  return useMemo(
    () =>
      paramStrings.map((paramString) => {
        return isHiddenByQueryParam(paramString, params);
      }),
    [paramStrings, params]
  );
}

function isHiddenByQueryParam(
  value: string,
  params: queryString.ParsedQuery
): boolean {
  if (!value || value === '') {
    return false;
  }

  const paramKey = value.split('=')[0];
  const paramVal = value.split('=')[1];

  if (params[paramKey] === paramVal) {
    return true;
  }

  return false;
}
